import React, { useEffect, useState } from 'react';
import styles from './BookingExtension.module.css';
import { Modal, Button, ConfigProvider } from 'antd';
import { connect } from 'react-redux';
import PropTypes from 'prop-types'
import store from '../../../store';
import { loadUser } from '../../../Actions/Auth';
import { BreathAPIs } from '../../../APIs/BreathAPIs';
import Helper from '../../../Utils/Helper';
import StripePayment from '../../../StripePayment/StripePayment';
import { toast } from 'react-toastify';
import HourMinuteSelector from './components/HourMinuteSelector';
import { FaMoon } from 'react-icons/fa';
import { Tooltip } from 'antd';

const BookingExtension = ({ user, booking, updateTrigger, location, userWalletBalance, userGroups,usersFreeChargingLocations, availableNightCharging, userAvgPower }) => {
    // console.log("bookng in extend: ", booking)
    // console.log("location in extend: ", location)
    const [isOvernightChargingEnabledInLocation, setIsOvernightChargingEnabledInLocation] = useState(location.overNightChargingEnabled)
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [isTooltipOpen, setIsTooltipOpen] = useState(false);
    const [updatedWallet, setUpdatedWallet] = useState([]);

    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [userLoading, setUserLoading] = useState(false);
    const [futureEstimate, setFutureEstimate] = useState(null);
    const [walletRechargeModal, setWalletRechargeModal] = useState(false);

    const [showError, setShowError] = useState(false);

    const [bookingList, setBookingList] = useState([]);
    const [expandableDuration, setExpandableDuration] = useState(null);

    const [isBookingExist, setIsBookingExist] = useState(null);
    const [nextSlotBooked, setNextSlotBooked] = useState(null);

    const [timeExtension, setTimeExtension] = useState(15);
    const [newEndTime, setNewEndTime] = useState(null);

    const [isExtendable, setIsExtendable] = useState(null);
    const [amountToAdd, setAmountToAdd] = useState(10)

    const [isNightCharging, setIsNightCharging] = useState(booking.isNightCharging)

    const [nightChargingEstimate, setNightChargingEstimate] = useState(booking.nightChargeEstimate)
    const [nightChargeEndLocalTZ, setNightChargeEndLocalTZ] = useState(null)
    // const [isFreeChargingForSelectedLocation, setIsFreeChargingForSelectedLocation] = useState(false);
    function getTimeDifferenceInMinutes(startTime, endTime) {
        const start = new Date(startTime);
        const end = new Date(endTime);
        return Math.floor((end - start) / (1000 * 60)); // Convert milliseconds to minutes
    }

    // console.log("location in endtime extend: ", booking.charger.location)

    const getTimeInChargerTimeZone = (timeStamp)=>{
        let selectedTimeInChargerTZ = new Date(timeStamp.toLocaleString('en-US', { timeZone: booking.charger.location.timezone }));
    //   let offset = selectedTimeInChargerTZ.getTime() - selectedTime.getTime();
    return selectedTimeInChargerTZ
    }

    const checkConflict = (existingBookings, startDateTime, endDateTime)=>{
        const conflictedBookings = existingBookings.filter(
      (b) =>
        (b._id !== booking._id) &&
        (
          (new Date(b.startTime) < endDateTime && new Date(b.endTime) > startDateTime) ||
          (new Date(b.endTime) > startDateTime && new Date(b.startTime) < endDateTime)
        )
    );
    return conflictedBookings;
    }


    const checkNightChargingPossible = (startTime, endTime, bookingData) =>{

        if(!isOvernightChargingEnabledInLocation){
            return {nightChargingPossibleWithoutDuration: false,  isNightChargingAvailable: false, connectorAvailableForNightCharge: false}
        }
        // return {nightChargingPossibleWithoutDuration,  isNightChargingAvailable, connectorAvailableForNightCharge}


        let nightChargingPossibleWithoutDuration = false;
        let isNightChargingAvailable = false



        let newStartTimeInChargerTZ = getTimeInChargerTimeZone(startTime)
      // console.log("selectedTimeInChargerTZ: ", selectedTimeInChargerTZ)
      let offset = newStartTimeInChargerTZ.getTime() - startTime.getTime();
    //   let newStartTimeInChargerTZ = new Date(selectedTimeInChargerTZ);
      // console.log("new start time in charger timezone; ", newStartTimeInChargerTZ)
      let nightChargeEndTime;

          if (newStartTimeInChargerTZ.getHours() >= 9 && newStartTimeInChargerTZ.getHours() <= 23) {
            nightChargeEndTime = new Date(new Date(newStartTimeInChargerTZ.getTime() + 24 * 60 * 60 * 1000).setHours(9, 0, 0, 0));
          }
          else {
            nightChargeEndTime = new Date(newStartTimeInChargerTZ.setHours(9, 0, 0, 0));
          }
      // console.log("night chargerEndTime: ", nightChargeEndTime)
      // console.log("offset : ", offset)
      let nightChargeEndTimeInLocalTZ = new Date(nightChargeEndTime.getTime() - offset);
      setNightChargeEndLocalTZ(nightChargeEndTimeInLocalTZ)
      let nightChargeStartTimeInLocalTZ = new Date(new Date(nightChargeEndTimeInLocalTZ).getTime() - (12 * 60 * 60 * 1000))
        
        // console.log("nightChargingConnector: ", nightChargingConnector)
        // check  conditons without duration using either nightChargingConnector  / 0 th connector
        // nightChargeStartTimeInLocalTZ, nightChargeEndTimeInLocalTZ, startDateTime
        // console.log("startDate time ; , ", startDateTime)
        // let bookingDurationForNightCharging = (nightChargingConnector !== null ? nightChargingConnector.availableDuration : connectorAvailabilityArray[0].availableDuration)
        let bookingStartDateTimeInLocalTZ = new Date(startTime)
        let bookingEndDateTimeInLocalTZ = new Date(endTime)

        
        //booking start < 9pm end > 9pm & < 8am  ->   9pm - booking end >= 3hr 
        if((bookingStartDateTimeInLocalTZ <= nightChargeStartTimeInLocalTZ) && (bookingEndDateTimeInLocalTZ > nightChargeStartTimeInLocalTZ) && (bookingEndDateTimeInLocalTZ <= nightChargeEndTimeInLocalTZ)){
          console.log("1st condition ")
          nightChargingPossibleWithoutDuration = true;
          if((bookingEndDateTimeInLocalTZ - nightChargeStartTimeInLocalTZ) >= 180 * 60 * 1000){
            isNightChargingAvailable = true
          }
        } //booking start < 8am & > 9pm  and booking end > 8am -> booking start - 8am >= 3hr
        else if((bookingStartDateTimeInLocalTZ <= nightChargeEndTimeInLocalTZ) && (bookingStartDateTimeInLocalTZ > nightChargeStartTimeInLocalTZ) && (bookingEndDateTimeInLocalTZ > nightChargeEndTimeInLocalTZ)){
          console.log("2nd condition")
          nightChargingPossibleWithoutDuration = true;
          if((nightChargeEndTimeInLocalTZ - bookingStartDateTimeInLocalTZ) >= 180 * 60 * 1000){
            isNightChargingAvailable = true
          }
        }// booking start < 9pm  and booking end > 8am -> night charging 
        else if((bookingStartDateTimeInLocalTZ <= nightChargeStartTimeInLocalTZ) && (bookingEndDateTimeInLocalTZ >= nightChargeEndTimeInLocalTZ)){
          console.log("3rd condition")
          nightChargingPossibleWithoutDuration = true;
          if((nightChargeEndTimeInLocalTZ - nightChargeStartTimeInLocalTZ) >= 180 * 60 * 1000){
            isNightChargingAvailable = true
          }
        }//booking start > 9pm & < 8 am  booking end >9pm & < 8am
        else if((bookingStartDateTimeInLocalTZ >= nightChargeStartTimeInLocalTZ) && (bookingStartDateTimeInLocalTZ < nightChargeEndTimeInLocalTZ) 
            && (bookingEndDateTimeInLocalTZ > nightChargeStartTimeInLocalTZ) && (bookingEndDateTimeInLocalTZ <= nightChargeEndTimeInLocalTZ)){
          console.log("4th condition")
               nightChargingPossibleWithoutDuration = true;
          if((bookingEndDateTimeInLocalTZ - bookingStartDateTimeInLocalTZ) >= 180 * 60 * 1000){
            isNightChargingAvailable = true
          }
          }

          let connectorAvailableForNightCharge  = checkConflict(bookingList, bookingStartDateTimeInLocalTZ, nightChargeEndTimeInLocalTZ).length > 0 ? false : true

        //   setDoesBookingEndExceedNightEnd(doesBookingEndExceedNightEndVar)
        //   // if(nightChargingPossibleWithoutDuration === false){
        //   //   setIsNightChargingPossible(false)
        //   //   setIsNightCharging(false)
        //   // }else{
        //   //   isNightChargingAvailable ? setIsNightCharging(true) : setIsNightCharging(false)
        //   //   setIsNightChargingPossible(true)
        //   //   // isNightChargingAvailable ? setIsNightChargingPossible(true) : setIsNightChargingPossible(false)
        //   //   // possibility of night charging 
        //   //   // cause wallet -> night connector available & isNightChargingAvailable false & nightCahrgingPossible without duration true
        //   // }
        
        //   console.log("nightChargingPossibleWithoutDuration: ", nightChargingPossibleWithoutDuration);
        //   console.log("is night charging available : ", isNightChargingAvailable)
        //   console.log("does bookng end Exceed night end : ", doesBookingEndExceedNightEndVar)
          return {nightChargingPossibleWithoutDuration,  isNightChargingAvailable, connectorAvailableForNightCharge}
    }
    // useEffect(() => {checkIsFreeCharging()}, [isModalVisible]);

    // const checkIsFreeCharging = () => {
    //     setIsFreeChargingForSelectedLocation(false)
    //       let isFreeCharging = false;
    //           userGroups.filter((userGroup) => {
               
        
    //               let parsedPermissions = JSON.parse(userGroup.permissions)
        
    //               try {
    //                 if (parsedPermissions?.freeCharging && parsedPermissions?.freeCharging === 'allowed') {
                      
        
    //                   if ("freeChargingAllowedLocations" in parsedPermissions) {
    //                     isFreeCharging = Helper.isFreeChargingAllowedInSelectedLocation(parsedPermissions.freeChargingAllowedLocations, usersFreeChargingLocations, booking?.charger?.location?._id) //isFreeChargingAllowedInSelectedLocation(parsedPermissions.freeChargingAllowedLocations)
    //                   } else {
    //                     isFreeCharging = Helper.isFreeChargingAllowedInSelectedLocation()
    //                   }
    //                   isFreeCharging ? setIsFreeChargingForSelectedLocation(true) : setIsFreeChargingForSelectedLocation(false)
    //                 //   console.log("isFreeCharging", isFreeCharging)
    //                 }
    //               } catch (error) {
    //                 console.log(error.message)
    //               }})
    //     return isFreeCharging
    // }
    const calculateEstimatedAmount = (totalTimeInSec, startTime, endTime, isCustomEnergyRateForLocation, customeEnergyRate) => {
        let chargerData = booking.charger
        chargerData.connector = [booking.connector]
        // let charger = [booking.charger];
        // console.log("booking charger: ", booking.charger)
        // console.log("booking connector: ", booking.connector)
        // charger[0].connector = [booking.connector]
        //calculateEstimatedAmount(time, startDateTime, endDateTime, selectedCharger, isBookingNonRes, isCustomEnergyRateForSelectedLocation, customEnergyRate, selectedChargerForNonRes, chargers, locationData, durationReFill, startInstantly
        // console.log("connector id : ", booking.connector)
        // console.log("charger list : ", chargerData)
        const onGoingBookingEstimate = Helper.calculateEstimatedAmount(totalTimeInSec, startTime, endTime, booking.connector._id, false, isCustomEnergyRateForLocation, customeEnergyRate, null, [chargerData], [booking.charger.location], 0, false, userAvgPower, isNightCharging);
        // console.log("onGoingBookingEstimate",onGoingBookingEstimate)
        return onGoingBookingEstimate;
    }

    const formatDate = (dateString, timeOnly = false) => {
        const dateToConvert = new Date(dateString);
        const options = timeOnly ?
            {
                hour: 'numeric',
                minute: 'numeric',
                hour12: user?.timeFormatAmPm
            }
            :
            {
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
                hour12: user?.timeFormatAmPm
            };

        let updatedFormat = dateToConvert.toLocaleTimeString(undefined, options);
        return updatedFormat;
    }

    useEffect(() => {
        if (isModalVisible) {
            setIsExtendable(true);
            const timeWithoutGrace = new Date(booking?.endTime);
            // console.log("GracePeriod in ext", booking?.gracePeriod)
            timeWithoutGrace.setMinutes(timeWithoutGrace.getMinutes() - booking?.gracePeriod);

            const currentTime = new Date();
            const timeDifference = timeWithoutGrace - currentTime;

            if (timeDifference <= 0) {
                setIsExtendable(false);
            } else {
                setTimeout(() => {
                    setIsExtendable(false);
                }, timeDifference);
            }

            return () => clearTimeout();
        }
    }, [isModalVisible]);



    useEffect(() => {
        const fetchData = async () => {
            if (booking && isModalVisible) {
                setUserLoading(true);
                try {
                    await store.dispatch(loadUser());
                    const lockedAmt = await BreathAPIs.getTotalFutureEstimate();
                    // console.log("locked amouont data setting future estimate",lockedAmt?.data)
                    setFutureEstimate(lockedAmt?.data)
                } catch (error) {
                    console.error("Error loading user:", error);
                    setShowError(true);
                } finally {
                    setUserLoading(false);
                }
                setTimeExtension(15);
            }
        };
        fetchData();
    }, [isModalVisible, booking]);


    const showModal = () => {
        setIsModalVisible(true);
    };

    useEffect(() => {
        setNextSlotBooked(null);
        setShowError(false);
        const checkBookingExist = async () => {
            try {
                setIsLoading(true);
                const bookingList = await BreathAPIs.getBookingList(
                    new Date(),
                    booking?.charger?.location?._id,
                    booking?.charger?._id,
                    booking?.connector?._id
                )
                // console.log("bookingList?.data?.bookings: ", bookingList?.data?.bookings)
                setBookingList(bookingList?.data?.bookings ? bookingList?.data?.bookings : []);
                setIsLoading(false);

            } catch (error) {
                console.log(error)
                setIsLoading(false);
                setShowError(true);

            }

        }
        const assignDuration = async ()=>{
            try{
                const maxLocationDuration = location?.maxChargeDuration ? location?.maxChargeDuration : 8;
            let totalDuration = getTimeDifferenceInMinutes(booking?.startTime, booking?.isNightCharging ? booking?.endTimeOverNight : booking?.endTime);
            if(location?.userMaxDurationLimit){

                // let chargerTime = Helper.convertToChargerTimeZone(new Date(selectedTime), locationDataArray[0].timezone) 
                // let chargerTimeEnd = chargerTime
                // let offSetBetweenChargerAndLocal = selectedTime ? selectedTime.getTime() - chargerTime.getTime() : 0
                // console.log("chargerTime, chargerTimeEnd", chargerTime, chargerTimeEnd)
                // let dayStart = chargerTime.setHours(0,0,0,0)
                // let dayEnd = chargerTimeEnd.setHours(23, 59, 59, 999)
                // dayStart = new Date(new Date(dayStart).getTime() + offSetBetweenChargerAndLocal)
                // dayEnd = new Date(new Date(dayEnd).getTime() + offSetBetweenChargerAndLocal)


                let chargerTime = Helper.convertToChargerTimeZone(new Date(booking?.startTime), location?.timezone) 
                let chargerTimeEnd = chargerTime
                let offSetBetweenChargerAndLocal = booking?.startTime ? new Date(booking?.startTime).getTime() - chargerTime.getTime() : 0
                let dayStart = new Date(chargerTime.setHours(0,0,0,0))
                let dayEnd = new Date(chargerTimeEnd.setHours(23, 59, 59, 999))
                dayStart = new Date(new Date(dayStart).getTime() + offSetBetweenChargerAndLocal)
                dayEnd = new Date(new Date(dayEnd).getTime() + offSetBetweenChargerAndLocal)
                let res = await BreathAPIs.getCurrentDayUserBookings(dayStart, dayEnd)
                let usedSecByUser = res.data
                totalDuration = usedSecByUser / 60
            }
            
            setExpandableDuration(((maxLocationDuration * 60) - totalDuration));
            }catch(err){
                console.log("err: ", err.message)
            }
        }

        if (isModalVisible) {
            checkBookingExist();
            assignDuration();
            
        }

    }, [isModalVisible])


    useEffect(() => {
        setIsBookingExist(null);

        if (!booking || !timeExtension) return;

        const startTime = booking.isNightCharging ? new Date(booking.endTimeOverNight) : new Date(booking.endTime);
        const endTime = new Date(startTime.getTime() + timeExtension * 60000);
        // console.log("proposed end time: ", endTime)
        // console.log("bookingList in time extension: ", bookingList
        // )
        // console.log("Start time: ", startTime, " End time: ", endTime)

        const hasConflict = bookingList?.some(({ startTime: existingStartTime, endTime, isNightCharging, endTimeOverNight }) => {
            // console.log("Night charging booking: ", isNightCharging, endTimeOverNight)
            let existingEndTime = isNightCharging ? endTimeOverNight : endTime;
            const existingStart = new Date(existingStartTime);
            const existingEnd = new Date(existingEndTime);

            // console.log("Existing booking - Start: ", existingStart, " End: ", existingEnd)
            // Check if the time intervals overlap
            return (
                (startTime >= existingStart && startTime < existingEnd) ||
                (endTime > existingStart && endTime <= existingEnd) ||
                (startTime <= existingStart && endTime >= existingEnd)
            );
        });


        setNewEndTime(endTime);

        setIsBookingExist(hasConflict);
        if (nextSlotBooked === null) {
            setNextSlotBooked(hasConflict)
        }

    }, [timeExtension, isModalVisible, bookingList]); 



    useEffect(() => {
        if (booking && isModalVisible && !userLoading) {
            // console.log("update wallet useeffect")
            if (futureEstimate !== null) {
                // console.log("new end date time; ", newEndTime)
                // console.log("inside setting updated wallet")
                setShowError(false);
                let {isFreeCharging, customEnergyRate, isCustomEnergyRateForSelectedLocation} = Helper.checkUserGroupPermissions(userGroups, booking?.charger?.location?._id,  usersFreeChargingLocations)
                // let isFreeChargingForUser = checkIsFreeCharging()
                // console.log("isFreeChargingForUser",isFreeChargingForUser)
                const { estimateAmount, startTime } = booking;
                const userWallet = user?.wallet?.coins;
                const lockedAmtWithoutThisBooking = futureEstimate - estimateAmount;
                const timeDifferenceInMinutes = (new Date(newEndTime) - new Date(startTime)) / (1000 * 60);
                const timeDifferenceInSeconds = (new Date(newEndTime) - new Date(startTime)) / (1000);

                let newEndTimeInChargerTimeZone = getTimeInChargerTimeZone(new Date(newEndTime))
                // console.log("newEndTimeInChargerTimeZone: ", newEndTimeInChargerTimeZone)
                let nightChargeVar = newEndTimeInChargerTimeZone.getHours() >= 9  ? false : booking.isNightCharging 
                let nightChargeAmount = newEndTimeInChargerTimeZone.getHours() >= 9  ? 0 : booking.nightChargeEstimate
                // setIsNightCharging( newEndTimeInChargerTimeZone.getHours() >= 8  ? false : booking.isNightCharging  )
                if(!booking.isNightCharging){
                    
                     if(timeDifferenceInMinutes >= 180 &&  newEndTimeInChargerTimeZone.getHours() < 9){
                       let {nightChargingPossibleWithoutDuration,  isNightChargingAvailable, connectorAvailableForNightCharge} = checkNightChargingPossible(new Date(startTime), new Date(newEndTime), booking)
                            
                            if(nightChargingPossibleWithoutDuration && isNightChargingAvailable && connectorAvailableForNightCharge){
                                nightChargeVar = true
                                nightChargeAmount = (nightChargeVar && availableNightCharging <= 0) ? 2 : 0
                                // check count and set nightChargeEstimate
                            }else{
                                nightChargeVar = false
                            }
                     }else{
                        nightChargeVar = false
                     }
                    // let newEndTimeInChargerTimeZone = getTimeInChargerTimeZone(newEndTime)
                    // setIsNightCharging( newEndTimeInChargerTimeZone.getHours() >= 8  ? false : booking.isNightCharging )
                }
                // else if(newEndTimeInChargerTimeZone.getHours() >= 9){
                //     nightChargeVar = false
                // }
                nightChargeAmount = isFreeCharging ? 0 : nightChargeAmount;
                setIsNightCharging(nightChargeVar);
                setNightChargingEstimate(nightChargeAmount);
                // }else{
                //     if(timeDifferenceInMinutes >= 180){
                //         // check night charge time then check slot available
                //     }
                // }



                //calculateEstimatedAmount(time, startDateTime, endDateTime, selectedCharger, isBookingNonRes, isCustomEnergyRateForSelectedLocation, customEnergyRate, selectedChargerForNonRes, chargers, locationData, durationReFill, startInstantly
                let { estimateAmount: updatedEstimateAmount } = isFreeCharging ? { estimateAmount: 0 } : calculateEstimatedAmount(timeDifferenceInMinutes, new Date(startTime), new Date(newEndTime), isCustomEnergyRateForSelectedLocation, customEnergyRate);
                // console.log("esti amt",estimateAmount, updatedEstimateAmount)
                
                // existing night charge same estimate , updated night charge check for condition
                // setNightChargingEstimate(nightChargeAmount)
                updatedEstimateAmount = updatedEstimateAmount + nightChargeAmount
                const updatedLockedAmt = lockedAmtWithoutThisBooking + updatedEstimateAmount ;
                const newWalletAmt = userWallet - updatedLockedAmt;
                const newEstimateAmountUpdated = updatedEstimateAmount - estimateAmount;

                setUpdatedWallet({
                    estimateAmount,
                    futureEstimate,
                    withoutThisBookingWallet: futureEstimate + estimateAmount,
                    updatedEstimateAmount,
                    newEstimateAmountUpdated,
                    timeDifferenceInMinutes,
                    timeDifferenceInSeconds,
                    startTime,
                    newEndTime,
                    newWalletAmt
                })

                if (newEstimateAmountUpdated > 10){
                    setAmountToAdd( Math.ceil(newEstimateAmountUpdated) )
                }
            }
            else {
                setShowError(true);
            }

        }
    }, [newEndTime, userWalletBalance, futureEstimate]);


    const handleOk = async () => {
        try {
            setIsSubmitting(true);
            const extendActionCreatedAt = new Date() 
            const result = await BreathAPIs.extendBookingTime(
                booking._id,
                updatedWallet.updatedEstimateAmount,
                updatedWallet.timeDifferenceInSeconds,
                updatedWallet.newEndTime,
                extendActionCreatedAt,
                isNightCharging,
                nightChargingEstimate,
                nightChargeEndLocalTZ
                
            );
            console.log('API result:', result);

            if (result?.status === 200) {
                toast.success(result?.data?.success?.msg || 'Booking updated successfully');
                console.log('Update successful');
                updateTrigger && updateTrigger();
            } else {
                toast.error(result?.data?.errors?.msg || 'Failed to update booking');
            }
            setIsSubmitting(false);
        } catch (error) {
            console.error('Error updating booking time:', error);
            if(error?.response?.data?.errors?.msg) {
                toast.error(error?.response?.data?.errors?.msg);
            }
            else {
                 toast.error('An unexpected error occurred');
            }
            setIsSubmitting(false);
        }

        setIsModalVisible(false);
    };


    const handleCancel = () => {
        console.log('Canceled starting earlier');
        setIsModalVisible(false);
    };

    if (user?.isGuest) {
        return null;
    }

    return (
        <ConfigProvider theme={{
            token: {
                colorPrimary: '#18365E',
                colorBgContainer: '#ffffff',
                boxShadow: 'none'
            },
        }}>
            <div className={styles['booking-extension-container']}>
                <button className={styles['booking-extension']} onClick={showModal}>
                    Extend booking?
                </button>

                {isModalVisible && <Modal
                    title="Extend booking?"
                    open={isModalVisible}
                    onOk={handleOk}
                    onCancel={handleCancel}
                    okText="Extend"
                    cancelText="Cancel"
                    okButtonProps={{
                        disabled: (
                            isBookingExist === true ||
                            isBookingExist === null ||
                            (userLoading || isLoading) || !isExtendable) ||
                            (updatedWallet?.newWalletAmt <= 0 && !user?.isAutoPayEnabled) ||
                            expandableDuration < 15
                        ,
                        loading: isSubmitting,
                    }}
                >
                    {(userLoading || isLoading || isExtendable === null) ?
                        <div>
                            <p className={`card-text placeholder-glow`}>
                                <span className="placeholder col-12 rounded"></span>
                            </p>
                            <p className={`card-text placeholder-glow`}>
                                <span className="placeholder col-8 rounded-pill"></span>
                            </p>
                        </div>
                        :

                        <div className={styles['booking-extension-content']}>
                            {showError || isExtendable === false || expandableDuration < 15 ?
                                <>

                                    {showError && <div className={`${styles['danger']} ${styles['center']}`}>
                                        Something want wrong !
                                    </div>}

                                    {isExtendable === false && <div className={`${styles['danger']} ${styles['center']}`}>
                                        Sorry, the extendable time has passed and cannot be extended further.
                                    </div>}

                                    {expandableDuration < 15 && <div className={`${styles['danger']} ${styles['center']}`}>
                                        Sorry, you have exceeded the maximum booking duration.
                                    </div>}
                                </>
                                :
                                <>
                                    <p>You can extend your current booking based on availability.</p>
                                    <div>
                                        Location :
                                        <span>
                                            <>
                                                {booking?.charger?.location?.locationName} 
                                            </>
                                        </span>
                                    </div>
                                    <div>
                                        Charger :
                                        <span>
                                            <>
                                                {booking?.charger?.chargerTag} {booking?.connector?.noOfConnectorsInCharger !== 1 ? ` - #${booking?.connector?.connectorNumber}` : ""}
                                            </>
                                        </span>
                                    </div>
                                    {
                                        nextSlotBooked ?
                                            <div className={`${styles['danger']} ${styles['center']}`}>
                                                Apologies, the next available slots are currently fully booked. Could you please check your timeline for an alternate slot!
                                            </div>
                                            :
                                            <>
                                                
                                                <div>
                                                    Current Booking Time : <span>{formatDate(booking?.startTime)} - {formatDate(booking?.isNightCharging ?  booking?.endTimeOverNight : booking?.endTime, true)}</span>
                                                </div>
                                                <div>
                                                    Time to extend :
                                                    <span>
                                                        <HourMinuteSelector onChange={(val) => { setTimeExtension(val) }} defaultMinute={timeExtension} maxSelectionInMin={expandableDuration} />
                                                    </span>
                                                </div>

                                                <div>
                                                    End Time : <span>{formatDate(newEndTime)}</span>
                                                </div>

                                                <div>
                                                    Amount needed for extra time : <span>${updatedWallet?.newEstimateAmountUpdated?.toFixed(2) < 0 ? 0.00 : updatedWallet?.newEstimateAmountUpdated?.toFixed(2)}</span>
                                                </div>
                                                <div>
                                                    New Estimated Amount : <span>${updatedWallet?.updatedEstimateAmount?.toFixed(2)}</span>
                                                </div>
                                                {isNightCharging ?  <p><FaMoon color="#e09839ff"></FaMoon>
                                                
                                                <Tooltip title="No idle fee until 9AM" color="#10396eff"
                    trigger="click" // Changes trigger from hover to click
                    open={isTooltipOpen} // Controls visibility
                    onOpenChange={(visible) => setIsTooltipOpen(visible)}>
                    <span style={{ color: "#10396eff" }} onClick={(e) => {
                      e.preventDefault();
                      setIsTooltipOpen(!isTooltipOpen);
                    }}> Overnight Booking </span>
                  </Tooltip>
                                                
                                                (monthly credits: {availableNightCharging} out of 4)</p> : "  "}

                                                {(updatedWallet?.newWalletAmt <= 0 && !user?.isAutoPayEnabled) && <div className={styles['danger']}>
                                                    You don't have enough balance to update : <span>
                                                        <button className={styles['button']} onClick={() => setWalletRechargeModal(true)}>Add Amount</button>
                                                    </span>
                                                </div>}

                                                {

                                                    isBookingExist === true
                                                        ?
                                                        <div className={`${styles['danger']} ${styles['center']}`}>
                                                            Apologies, this slot is already booked. Kindly choose a different time.</div>
                                                        : <></>
                                                }

                                            </>

                                    }
                                </>
                            }

                        </div>

                    }

                    {walletRechargeModal && <Modal open={walletRechargeModal} onCancel={() => { setWalletRechargeModal(!walletRechargeModal) }} footer={null}>
                        <StripePayment setWalletRechargeModal={setWalletRechargeModal} amountToAdd={amountToAdd} />
                    </Modal>}


                </Modal>}
            </div>
        </ConfigProvider>
    );
};

BookingExtension.propTypes = {
    user: PropTypes.object,
    userWalletBalance: PropTypes.number,
    userGroups: PropTypes.array,
    usersFreeChargingLocations: PropTypes.array,
    availableNightCharging: PropTypes.number,
    userAvgPower: PropTypes.object,
}
const bookingExtensionProps = state => ({
    user: state.auth && state.auth.user ? state.auth.user : null,
    userWalletBalance: state.auth && state.auth.user ? state.auth.user.wallet.coins : null,
    userGroups: state.auth && state.auth.user ? state.auth.user.userGroups : [],
    usersFreeChargingLocations: state.auth && state.auth.user ? state.auth.user.freeChargingAllowedLocations : [],
    availableNightCharging: state.auth && state.auth.user ? state.auth.user.availableNightCharging : 0,
    userAvgPower: state.auth && state.auth.user ? state.auth.user.avgPower : null,
})

export default connect(bookingExtensionProps, {})(BookingExtension);
